import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { FilterControlParams } from '../../../interfaces/filter-control-params';

@Component({
  selector: 'bm-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss']
})
export class DateFilterComponent implements OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() control: FilterControlParams;

  constructor() {}

  ngOnInit() {}
}
